'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiImage = require('@spp/ui-image');

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultArticleRenderer = function defaultArticleRenderer(article, imageAssetSizes, theme) {
    var imageAsset = article.promotionContent.imageAsset ? _react2.default.createElement(_uiImage.ImageAsset, {
        theme: theme.image,
        urls: article.promotionContent.imageAsset.urls,
        sizes: imageAssetSizes,
        testTag: '@spp/ui-article-list:image-asset'
    }) : null;

    return _react2.default.createElement(
        'a',
        {
            className: theme.articleLink,
            'data-test-tag': '@spp/ui-article-list:link',
            href: article.links.canonicalUrl,
            'aria-label': article.promotionContent.title.value
        },
        imageAsset,
        _react2.default.createElement(
            'span',
            { className: theme.articleHeader },
            article.promotionContent.title.value
        )
    );
};

var articlesListItems = function articlesListItems(articles, imageAssetSizes, articleRenderer, theme) {
    return articles.map(function (article) {
        return _react2.default.createElement(
            'li',
            { key: article.id, className: theme.listItem },
            articleRenderer(article, imageAssetSizes, theme)
        );
    });
};

var ArticleList = function ArticleList(_ref) {
    var header = _ref.header,
        ariaLabel = _ref.ariaLabel,
        articleList = _ref.articleList,
        imageAssetSizes = _ref.imageAssetSizes,
        articleRenderer = _ref.articleRenderer,
        theme = _ref.theme;
    return _react2.default.createElement(
        'section',
        { className: theme.root },
        _react2.default.createElement(
            'h2',
            { className: theme.header },
            header
        ),
        _react2.default.createElement(
            'ul',
            { className: theme.articlesList, 'aria-label': ariaLabel },
            articlesListItems(articleList, imageAssetSizes, articleRenderer, theme)
        )
    );
};

ArticleList.propTypes = {
    header: _propTypes2.default.string.isRequired,
    articleList: _propTypes2.default.arrayOf(_propTypes2.default.shape({ // iris-core pages response
        links: _propTypes2.default.object,
        promotionContent: _propTypes2.default.shape({
            description: _propTypes2.default.object,
            imageAsset: _irisPropTypes.objects.imageAsset,
            title: _propTypes2.default.object
        })
    })).isRequired,
    imageAssetSizes: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string,
        header: _propTypes2.default.string,
        article: _propTypes2.default.string,
        articlesList: _propTypes2.default.string,
        listItem: _propTypes2.default.string,
        articleLink: _propTypes2.default.string,
        articleHeader: _propTypes2.default.string,
        articleDescription: _propTypes2.default.string,
        image: _propTypes2.default.string
    }),
    articleRenderer: _propTypes2.default.func,
    ariaLabel: _propTypes2.default.string.isRequired
};

ArticleList.defaultProps = {
    theme: {},
    imageAssetSizes: '',
    articleRenderer: defaultArticleRenderer
};

exports.default = ArticleList;
//# sourceMappingURL=ArticleList.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-article-list/lib/cjs/ArticleList.js
 ** module id = 563
 ** module chunks = 1
 **/